export enum InvoiceVerificationFieldName {
  CompanyId = 'companyId',
  CounterpartyId = 'counterpartyId',
  CounterpartyName = 'counterpartyName',
  CounterpartyRegistrationNumber = 'counterpartyRegistrationNumber',
  CounterpartyVatNumber = 'counterpartyVatNumber',
  CurrencyId = 'currencyId',
  DocumentDescription = 'documentDescription',
  DocumentType = 'documentType',
  DueDate = 'dueDate',
  ExpenseType = 'expenseType',
  InvoiceAmount = 'invoiceAmount',
  InvoiceDate = 'invoiceDate',
  InvoiceNumber = 'invoiceNumber',
  IsCounterpartyValidated = 'isCounterpartyValidated',
  IsPrepaid = 'isPrepaid',
  IsReimbursement = 'isReimbursement',
  PaymentChannel = 'paymentChannel',
  ReimbursementCounterpartyId = 'reimbursementCounterpartyId',
  ReimbursementCounterpartyName = 'reimbursementCounterpartyName',
  ReimbursementIban = 'reimbursementIban',
  Tags = 'tags',
  VatAmount = 'vatAmount',
  VatBase = 'vatBase'
}
